/**
 * External dependencies
 */
import BaseModal from "react-modal";
import { noop } from "lodash";
import classNames from "classnames";
import Button from "components/button";
import Icon from "components/icon";
import { Text } from "components/text";

/**
 * Style dependencies
 */
import "./styles.scss";

const Modal = ({
  children,
  title,
  description,
  headerActions,
  baseClassName = "modal",
  className = "",
  isVisible,
  close = noop,
  header = true,
  ...props
}) => {
  const renderButton = (button, index) => {
    return (
      <Button key={button.action} {...button}>
        <span className={`${baseClassName}__button-label`}>{button.label}</span>
      </Button>
    );
  };

  const renderButtonsBar = () => {
    if (!props.buttons) {
      return null;
    }
    return (
      <div className={`${baseClassName}__action-buttons`}>
        {props.buttons.map(renderButton, this)}
      </div>
    );
  };

  return (
    <BaseModal
      className={classNames(baseClassName, className)}
      isOpen={isVisible}
      onRequestClose={close}
      overlayClassName="modal__overlay"
      ariaHideApp={false}
    >
      {header && (
        <div className="modal__header">
          <div>
            {title && (
              <div className="modal__header-title">
                <Text variant="headingXs">{title}</Text>
              </div>
            )}
            {description && (
              <div className="modal__header-description">{description}</div>
            )}
          </div>
          {(headerActions && (
            <div className="modal__header-actions flex flex-row items-center justify-end">
              {headerActions}
              <button
                className="modal__header-close-btn"
                onClick={() => close()}
              >
                <Icon size={25} name="RiCloseLine" />
              </button>
            </div>
          )) || (
            <button className="modal__header-close-btn" onClick={() => close()}>
              <Icon size={25} name="RiCloseLine" />
            </button>
          )}
        </div>
      )}
      <div className={classNames("modal__content")}>{children}</div>
      {renderButtonsBar()}
    </BaseModal>
  );
};

export default Modal;
